import Parallax	from "./circuits/parallax.js";

class FeedPump extends Parallax {
	constructor(p) {
		super(0x10, 4);
	}
	update() {
		return( new Promise(function(resolve, reject) {
			resolve(true);
		}.bind(this)) );
	}
	toJSON() {
		return({
			id: this.id,
			status: this.status,
			rpm: this.rpm,
			mlh: this.mlh,
			calibrationStatus: this.calibrationStatus,
			sumML: this.sumML
		});
	}
}

export default FeedPump;